import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MenuOptionsService {

  active_link="";
  ps_api_end_point;
  
  constructor(private http: HttpClient) { 
    this.ps_api_end_point = environment.browse_data_api_endpoint;
  }

  get_release_notes(){
    return this.http.get(`${this.ps_api_end_point}/jobmanagement/releasenotes`)
  }

}
